export default __webpack_public_path__ + "static/media/Linux.5888d746.svg";